import React, { useState, useEffect } from 'react';
import TopInfo from '@/components/mainApply/topInfo-erp';
import MaterialTable from '@/components/mainApply/erp/index';
import { getQuery } from '@/common/utils';
import { getInviteInfo } from '@/apis/invite';
import './index.less';

export default (props) => {
  const [actInfo, setActInfo] = useState({});
  const activityId = getQuery('activityId');
  useEffect(() => {
    getInviteInfo({
      activityId,
    }).then((response) => {
      if (response.ret === '0') {
        setActInfo(response.data || {});
      }
    });
  }, [activityId]);
  return (
    <div className="normal-shop">
      <TopInfo actInfo={actInfo} />
      <div style={{ paddingLeft: 16 }}>
        {actInfo && <MaterialTable ruleType="newInvite" activityId={activityId} actInfo={actInfo} />}
      </div>
    </div>
  );
};
